import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-custom-multi-select',
  templateUrl: './custom-multi-select.component.html',
  styleUrls: ['./custom-multi-select.component.css']
})
export class CustomMultiSelectComponent implements OnInit {

  @Output() selectionChange = new EventEmitter<number[]>(); // Emit selected options
  @Input() options: { id: number; name: string }[] = []; // List of options
  @Input() defaultOptions: number[] = []; // List of options
  @Input() initialOptionsText: string = 'Select Chauffuer(s)';
  @Input() isMulti: boolean = true;
  @Input() disable: boolean = false;
  @Input() enableDiselection: boolean = false;


  searchTerm: string = '';
  selectedOptions: number[] = [];
  filteredOptions: { id: number; name: string }[] = [];
  initialOptions: { id: number; name: string }[] = [];
  dropdownOpen: boolean = false;
  selectAllChecked: boolean = false;
  selectedOptionsText: string;

  constructor(){
  }

  ngOnInit(): void {
    document.addEventListener('click', this.onClickOutside.bind(this));
    this.selectedOptionsText = this.initialOptionsText;
    this.selectedOptions = this.defaultOptions;
    this.updateSelectedOptionsText();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.filteredOptions = this.options;
      this.initialOptions = this.options;
      this.selectedOptions = [];
      this.selectedOptionsText = this.initialOptionsText;
    }
    if (changes['initialOptionsText']) {
      this.selectedOptionsText = this.initialOptionsText;
    }
    if (changes['defaultOptions']) {
      this.selectedOptions = this.defaultOptions;
      this.updateSelectedOptionsText();
    }
  }

  // Toggle dropdown open/close
  toggleDropdown(state: boolean): void {
    if(this.disable){return};
    this.dropdownOpen = state;
    if (!state) {
      this.updateSelectedOptionsText();
    }
  }

  // Filter options based on search term
  onSearchChange(): void {
    this.filteredOptions = this.options.filter(option =>
      option.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  // Toggle individual option selection
  toggleOption(optionId: number, $event: any): void {
    $event.stopPropagation();
    const index = this.selectedOptions.indexOf(optionId);
    if(this.isMulti){
      if (index === -1) {
        this.selectedOptions.push(optionId);
      } else{
        this.selectedOptions.splice(index, 1);
      }
    }else {
      if (index === -1) {
        this.selectedOptions = [optionId];
      } else if(!this.enableDiselection){
        this.selectedOptions = [];
      }else {
        this.closeDropdown();
      }
    }


    this.checkSelectAllState();
    this.updateSelectedOptionsText();
    this.emitSelectionChange();
  }

  // Toggle "Select All" option
  toggleSelectAll($event: any): void {
    $event.stopPropagation();
    if (this.selectAllChecked) {
      this.selectedOptions = [];
      this.selectAllChecked = false;
    } else {
      this.selectedOptions = this.options.map(option => option.id);
      this.selectAllChecked = true;
    }
    this.updateSelectedOptionsText();
    this.emitSelectionChange();
  }

  // Check if "Select All" should be checked based on selection
  checkSelectAllState(): void {
    this.selectAllChecked = this.selectedOptions.length === this.options.length;
  }

  // Update the display text based on selected options
  updateSelectedOptionsText(): void {
    if (this.selectedOptions.length === 0) {
      this.selectedOptionsText = this.initialOptionsText;
    } else if (this.selectedOptions.length === 1) {
      const selectedDriver = this.initialOptions.find(driver => driver.id === this.selectedOptions[0])?.name;
      if (selectedDriver && selectedDriver.length > 10) {
        this.selectedOptionsText = `${selectedDriver.substring(0, 10)}...`;
      } else {
        this.selectedOptionsText = selectedDriver || ''; // fallback in case name is undefined
      }
    } else {
      const firstSelectedDriver = this.options.find(driver => driver.id === this.selectedOptions[0])?.name;
      if (firstSelectedDriver && firstSelectedDriver.length > 10) {
        this.selectedOptionsText = `${firstSelectedDriver.substring(0, 10)}... (+${this.selectedOptions.length - 1})`;
      } else {
        this.selectedOptionsText = `${firstSelectedDriver || ''} (+${this.selectedOptions.length - 1})`;
      }
    }
  }


  // Emit selected options
  emitSelectionChange(): void {
    this.selectionChange.emit(this.selectedOptions);
  }

  // Check if an option is selected
  isOptionSelected(optionId: number): boolean {
    return this.selectedOptions.includes(optionId);
  }

  // Close dropdown when clicking outside
  closeDropdown(): void {
    this.dropdownOpen = false;
  }

  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const insideDropdown = target.closest('.multi-select-container');
    if (!insideDropdown) {
      this.dropdownOpen = false;
    }
  }

  ngOnDestroy(): void {

  }
}
